module.exports = __webpack_public_path__ + "img/let_it_go.c008a24e.gif";